import { fromJS , OrderedMap} from 'immutable';
import { TimelineMax, TweenMax,Ease } from 'gsap';
import config from '../config/app.json';
import { preloadTextFonts } from '../helpers/utilityMethods';

const initialState = fromJS({
  "appLoadProgressValue": 0,
  "t1" : new TimelineMax({ paused: true}),
  "selectedScene": 0,
  "selectedItems": [],
  "selectedCamera": "",
  "selectedKeyframe": "",
  "userColors": [],
  "userFonts" : [],
  "isPlay": false,
  "isPlayAll": false,
  "fromStart" : false,
  "isPreview":false,
  "zoomFactor": 1,
  "textStatus": {},
  "isWorkspaceTextFocus": false,
  "textOptions" : {fontFamily : {disabled : false, isActive : false, value : null}, fontSize : {disabled : false, isActive : false, value : null}, fontWeight : {disabled : false, isActive : false, value : null }, fontStyle : {disabled : false, isActive : false, value : null}, textDecoration : {disabled : false, isActive : false, value : null}, bullet : {disabled : false, isActive : false, value : "none"}, textAlign : {disabled : false, isActive : false, value : null}, textTransform : {disabled : false, isActive : false, value : null}, color : {disabled : false, isActive : false, value : null}, link : {disabled : false, isActive : false, value : null}, opacity : {disabled : false, isActive : false, value : null}, lineSpacing : {disabled : false, isActive : false, value : null}, wordSpacing : {disabled : false, isActive : false, value : null}, letterSpacing : {disabled : false, isActive : false, value : null}, colors : []},
  "transformStatus": { transforming: false, moving: false, resizing: false, rotating: false },
  "currentPosition": null,
  "isCropping": false,
  "isFraming": false,
  "isBgCropping": false,
  "isVideoCroping" : false,
  "cropVideoId" : null,
  "swapDetails": null,
  "visibleTimelineTab": "objectTab",
  "audioPlayHead": 0,
  "displayDuration": 32470,  
  "animdisplayDuration":30,
  "timeScaleZoom": 0,
  "animTimeScaleZoom": 0,
  "selectedMedias": [],
  "timelineHeight": 130,
  "showSlidePanel": true,
  "workspaceBounds" : {},
  "tweenCount":0,
  "loadCount":0,
  "showLibrary":true,
  "workspaceGrid" : false,
  "copiedItem": null,
  "isCopyObject": false,
  "isPasteObject": false,
  "isCutObject": false,
  "workspaceBgImages":{},
  "propertyWindow" : {component : "", isOpened : false},
  "userFolders":{items:OrderedMap(), parent: {parent: "0", name: "My Files"}},
  "userMainFolders":{parent: {parent: "0", name: "My Files"}},
  "BGDrop":"",
  "textUpdated":null,
  "clonedBgFilter": "",
  "enableAutoSave":false,
  "commonPopup":{ popup : '', show:false},
  "isSaving": false,
  "loadprebuilt": {load: false, src: ''},
  "isToolBarExpanded" : true,
  "projectType" : "horizontal",
  "selectedScenes" : [],
  "animakerType" : 'full',
  "innerActiveTab" : 'PREBUILT',
  "currentActiveTab" : 'library',
  "multimovePlayHead" : null,
  "projectid":"",
  "projectUsr":"",
  "projectUsrImg":"",
  "socketid":"",
  "selectionBox" : {},
  "connections":{},
  "openLibrarySection" : false,
  "screenshots":{},
  "projectThumb":"",
  "audioSync" : false,
  "addNewScene":false,
  "recentColors" : [],
  "screenShotsHandler" : {frequency : 5, currentCount : 0, random : Math.random(), loading : false},
  "workspaceStage" : { 
    left :{menu : 70, library : 350, toggle : 20, padding : 0}, 
    top : {menu : 60, zoomControlMargin : 10, zoomControl : 0, padding : 0}, 
    right : { maxPropertyWindow : 300, padding : 0}, 
    bottom : {timeline : 0, playerControlMargin : 0, playerControl : 0, padding : 0}, 
    workspace : {sceneToolBarMargin : 0, sceneToolbar : 0} },
  "toastNotifications" : [],
  "colorPalettes" : {},
  "themes" : {},
  "addressBook" : [],
  "sharedWith" : [],
  "oldTimelineTab":"objectTab",
  "loaders" : {sharing : false, exporting : false},
  "userDetails" : {},
  "loadedFonts" : {fonts : {}, scenes : [], fontTracking : {}},
  "audiosTracked": false,
  "saveHandler" : {scenes : [], count : 0, limit : 5},
  "editClicked":false,
  "confirmPopup" : {show : false},
  "playRunningTime" : { seconds: "00", minutes: "00", hours: "00" },  
  "undoProp"  : {},
  'isUploadInProcess' : false,
  'isUploadFromOutside' : false, 
  "toolPreviewStarted" : false,
  'browserName' : navigator.userAgent.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i),
   "tempPlayhead":0,
   "anymsUploadStatus" : null,
   "highlightUpload" : false,
   "isEdit" : false,
   "isToolCropping" : false,
   "isFullScreen" : false,
   "currentScene": null,
   "currentSceneNumber": null , 
   "currentSceneStartTime":null,
   "currentSceneDuration":null,
   "autoPlay":false,
   "isFit":true,
   "isapplyEffecttoAllSlides":false,
   "hyperLinkData": {isHyperLinkEnabled: false,isHyperLinkAdded: false},
   "isProjectRestore":false,
   "isfontLoadedTxtGrp":false,
   "isShapeInGrp":false,
 

  suggestionPopup : {
    show : false,
    type : ''
  },
  nextBtnClicked : false,
  isSuggestionOn : true,
  isSugg : false,
  firstLoad : true,
  suggPos : {},
  isUserActive : 0,
  addedUpload : {
    addUpload : false,
    sceneNo : 0
  },
  fileToUpload : '',
  itemToUpdate : '',
  draggedFile: '',
  "isLoaded": false,
  "isPlayerTweenComplete": false,
  "isWsTweenComplete": false,
  textOffset : 0,
  zoomVideoStatus : null,
  actionSearchProgress:true,
  templateThumbnails : {thumbnails : [], status : null},
  libCurrentFolder : 'My Files',
  libSection:null,
  labelData:{},
  isNewAction : false ,
  loadComplete:false,
  bgCategoryLoad:false,
  "slideLabelData":[],
  isTextClicked :false,
  "assetArray":[],

})

const randomColors = ["#00bcd4", "#FFEB3B", "#8bc34a", "#ff9800", "#673ab7", "#ff5722","#f27927", "#f95d77", "#e34840", "#f985e4", "#9378d6"];

const changeTimelineDisplayDuration= (duration, zoomPercentage)=>{
  let newDisplayDuration = duration-duration*zoomPercentage/100;
 return parseInt(newDisplayDuration, 10) < 1 ? 1 : parseFloat(newDisplayDuration.toFixed(1));
}

function disableSelection(state){
  state = state.set("selectedItems", fromJS([]));

  
  state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
  
  return state;
}
function getZoom(workspaceStage, workspaceWidth, workspaceHeight, zoomFactor, isFit){ 
  var padding = 0
  if(isFit)
    padding = 30
  var stageLeft   = workspaceStage.getIn(["left", "menu"]) + workspaceStage.getIn(["left", "library"]) + workspaceStage.getIn(["left", "toggle"]) + workspaceStage.getIn(["left", "padding"]) + padding;
  var stageTop    = workspaceStage.getIn(["top", "menu"]) + workspaceStage.getIn(["top", "zoomControlMargin"]) + workspaceStage.getIn(["top", "zoomControl"]) + workspaceStage.getIn(["top", "padding"]) +padding ;
  var stageRight  = window.innerWidth - (workspaceStage.getIn(["right", "maxPropertyWindow"]) + workspaceStage.getIn(["right", "padding"]) + padding + workspaceStage.getIn(["workspace", "sceneToolBarMargin"]) + workspaceStage.getIn(["workspace", "sceneToolbar"]));
  var stageBottom = window.innerHeight - (workspaceStage.getIn(["bottom", "timeline"]) + workspaceStage.getIn(["bottom", "playerControlMargin"]) + workspaceStage.getIn(["bottom", "playerControl"]) + padding + workspaceStage.getIn(["bottom", "padding"]));


  var stageWidth  = stageRight - stageLeft;
  var stageHeight = stageBottom - stageTop;

  let scale;
  if(!workspaceStage.get("isLocked")){
  var widthScale = stageWidth / workspaceWidth;
  var heightScale = stageHeight / workspaceHeight;
  scale = Math.min(widthScale , heightScale);    
}
else{
    scale = zoomFactor;
}
  
  return scale;
}

function getPropertyWindowWidth(showSlide , windowName)
{
  let width = 300;
    if(!showSlide && windowName===""){
      width = 0 ;
    }
    // else if(windowName === "action"){width = 355;}
    // else if(windowName === "settings" ||  windowName === "animate" || windowName === "filterSetting" || 
    // windowName === "color"){width = 300 ;}
    // else if( windowName ==="transition"){width = 325;}
    // else if( windowName ==="bgColor"){width = 260;}
    // else{width= 230;}
  return width;
}

export default function localStore(state = initialState, action) {

  switch (action.type)
  {
    case "APP_LOAD_PROGRESS" :
      state = state.set("appLoadProgressValue", state.get("appLoadProgressValue")+action.data)
    return state;

    

    case 'FETCH_ACTION_SEARCH':
        state = state.setIn(['actionSearchProgress'], true);
      return state;

    case 'LOAD_ACTIONSEARCH_DATA':
        state = state.setIn(['actionSearchProgress'], false);
      return state;



    case 'SUGGESTION_POPUP':
      state = state.setIn(['suggestionPopup', 'show'], action.data.show);
      state = state.setIn(['suggestionPopup', 'type'], action.data.type);
      state = state.setIn(['suggestionPopup', 'subType'], action.data.subType);
      return state;

    case 'SUGG_POS':
        state = state.setIn(['suggPos', 'top'], action.data.top);
        state = state.setIn(['suggPos', 'left'], action.data.left);
        return state;
      
  

    case 'NEXT_BTN_CLICKED' :
      state = state.setIn(['nextBtnClicked'], action.data);
      return state;

    case 'UPDATE_SUGGESTION' : 
      state = state.setIn(['isSuggestionOn'], action.data);
      return state;
      
  
    case 'UPDATE_USER_ACTIVE':
      state = state.setIn(['isUserActive'], action.data);
      return state; 

    case "EDIT_CLICKED":
      state=state.set('editClicked',!state.get('editClicked'));
      return state
    
  
    case "DROP_NEW_SCENE":
      state = state.setIn(["addNewScene"], action.data)
      return state;

    case 'ADDED_UPLOAD' :
      state = state.setIn(['addedUpload', 'addUpload'], action.data.addUpload);
      state = state.setIn(['addedUpload', 'sceneNo'], action.data.sceneNo);
      return state;

    case 'FILE_TO_UPLOAD':
      state = state.set('fileToUpload', action.data);
      return state;

    case 'ITEM_TO_UPDATE':
      state = state.set('itemToUpdate', fromJS(action.data));
      return state;

    case "INITIATE_PROJECT":
        state = state.set("displayDuration",action.data.project.duration);
        state = state.set("animdisplayDuration",action.data.project.scenes[0].duration); 
        state = state.set("width", action.data.project.width); 
        state = state.set("height", action.data.project.height); 
        if(action.data.project.scenes[0].workspaceBG.type === "STOCKVID" || action.data.project.scenes[0].workspaceBG.type === "UPVIDEO")
        {
          state = state.set("timelineHeight",130)
          state = state.set("visibleTimelineTab","musicTab")
          state = state.setIn(["workspaceStage", "bottom", "timeline"], 130);
        }

        if(action.data.project.scenes[0] !== undefined){
          if(action.data.project.scenes[0].workspaceBG.type === "ZOOM" && action.data.project.scenes[0].workspaceBG.isBlob){
            state = state.set("zoomVideoStatus", "start");
          }
          let loadedFonts = fromJS([]);
          for(let i = 0; i < action.data.project.scenes.length; i++ ){ 
            let scene = fromJS(action.data.project.scenes[i]);
            allTextItems = scene.get("workspaceItems").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"});
            allTextItems = allTextItems.merge(scene.get("workspaceChildren").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"}));
            console.log(allTextItems)
            if(allTextItems.size > 0){  // eslint-disable-next-line 
              allTextItems.entrySeq().forEach(([key, value]) => {
                var textData = value.get("textData");  // eslint-disable-next-line 
                if(loadedFonts.find(x => (textData.getIn(["formats", "containerStyle", "fontFamily"]) && x.get("load") === textData.getIn(["formats", "containerStyle", "fontFamily"]).replace(/^[\"]|[\"]$/g, ""))) === undefined && textData.getIn(["formats", "others", "family"]) !== undefined && (textData.getIn(["formats", "others", "cssUrl"]) || !textData.getIn(["formats", "others", "isUserFont"]))){
                  const userFontUrl = config.UPLOADS.font_src;
                  const assetUrl = config['ASSETS'][config['ASSETS']['current']];
                  const cssUrl = textData.getIn(["formats", "others", "cssUrl"]) || textData.getIn(["formats", "others", "family"]);
                  const url = textData.getIn(["formats", "others", "isUserFont"]) && !cssUrl.includes("admin-fonts") ? (cssUrl.indexOf("https://") === 0 ? cssUrl : `${userFontUrl}${cssUrl}`) : (cssUrl.indexOf("https://") === 0 ? cssUrl : `${assetUrl}animaker/admin-fonts/${cssUrl}.css`);
                  loadedFonts = loadedFonts.push(fromJS({font : textData.getIn(["formats", "others", "family"]), load : textData.getIn(["formats", "containerStyle", "fontFamily"]), byUser : textData.getIn(["formats", "others", "isUserFont"]) === true, isLoaded : false,  url}));
                }
                const partialFonts = preloadTextFonts(textData.get("htmlText"));

                for(const fontData of partialFonts) {

                  if(loadedFonts.find(x => x.get("url") === fontData.url) === undefined){
                    loadedFonts = loadedFonts.push(fromJS(fontData));
                  }
                }
              });
            }
          }

          let prevLoadedFonts = state.getIn(["loadedFonts", "fonts"]);
          if (prevLoadedFonts && prevLoadedFonts.size > 0) { // when initiate project is called second time (for pptx import), we need to maintain previous font load status to prevent infinite loader in text component
            let groupedPrevLoadedFonts = prevLoadedFonts.groupBy((loadedFont) => loadedFont.get("load"));
            let groupedNewLoadedFonts = loadedFonts.groupBy((loadedFont) => loadedFont.get("load"));

            groupedNewLoadedFonts.forEach((newLoadedFontList, newLoad) => {
              if (groupedPrevLoadedFonts.get(newLoad) === undefined) {
                newLoadedFontList.forEach((newLoadedFont) => {
                  prevLoadedFonts = prevLoadedFonts.push(newLoadedFont);
                });
              }
            });
            loadedFonts = prevLoadedFonts;
          }
          state = state.setIn(["loadedFonts", "fonts"], loadedFonts);
        }
       
      return state;
    
    case "LOAD_COLOR_THEMES":
      
      if(action.data !== undefined){
        if(action.data.colorPalettes !== undefined){
          let val = OrderedMap({});
          OrderedMap(action.data.colorPalettes).map((v, i) => {
            val = val.set(i, fromJS(v))
          });
          state = state.set("colorPalettes", val);
        }
        if(action.data.themes !== undefined)
          state = state.set("themes", fromJS(action.data.themes));
      }
      
    return state;

    case "SET_SELECTED_ITEMS_COMPLETE":
      
      if (action.socketid !== action.currentSocketId)
      {
      
        let connections = state.get("connections");
        if(!connections.has(action.socketid)){
          var color = randomColors[0];
          state = state.setIn(['connections', action.socketid, "color"], color);
        }
        
        state = state.setIn(['connections', action.socketid, "selectedItems"], action.selectedItems);
        state = state.setIn(['connections', action.socketid, "projectUsr"], action.projectUsr);
        state = state.setIn(['connections', action.socketid, "userId"], action.userId);
        state = state.setIn(['connections', action.socketid, "projectUsrImg"], action.projectUsrImg);
       
      }

      return state;

    case "SET_SELECTED_SCENE_COMPLETE":
      if (action.socketid !== action.currentSocketId)
      {
       
        let connections = state.get("connections");
        if(!connections.has(action.socketid)){
          color = randomColors[0];
          state = state.setIn(['connections', action.socketid, "color"], color);
        }
        state = state.setIn(['connections', action.socketid, "selectedScene"], action.selectedItems);
        state = state.setIn(['connections', action.socketid, "projectUsr"], action.projectUsr);
        state = state.setIn(['connections', action.socketid, "userId"], action.userId);
        state = state.setIn(['connections', action.socketid, "projectUsrImg"], action.projectUsrImg);
      }

      return state;

    case "AUTO_SAVE_DATA":
      state = state.set("enableAutoSave", action.data);
      return state;

    case "SAVE_START":
      state = state.set("isSaving", true);
      return state;

    case "SAVE_DONE":
      state = state.set("isSaving", false);
      return state;

    case "CHANGE_LIB_BG":
     
      state = state.set("BGDrop", action.data);
      return state;

    case "LOAD_PROJECT":
      state = state.set("projectid", action.projectid);
      state = state.set("projectUsr", action.projectUsr);
      state = state.set("socketid", action.socketid);
      state = state.set("userId",action.userId);
      state = state.set("projectUsrImg",action.projectUsrImg);
      if(action.mode==='slide'){
      state = state.set("isPreview",true);
      }
    return state;


    case "ADD_SCENE_COMPLETE":
    
    if(action.currentSocketId === action.socketId)
    {
      state = state.set("selectedScene", action.slideIndex);
      state = state.set("selectedItems", fromJS([]));
      if(state.getIn(["propertyWindow", "component"]) !== "")
      {
        state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      state = state.set("selectedMedias", fromJS([]));
      state = state.set('audioPlayHead', action.newslide.startTime);
      state = state.setIn(["addNewScene"], false)
      state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
      if(state.get("visibleTimelineTab")==="musicTab" || state.get("visibleTimelineTab")==="bgColorTab" ){
      let newTime = state.get("displayDuration")+action.newslide.duration;
      state = state.set("displayDuration",  changeTimelineDisplayDuration(newTime, state.get("timeScaleZoom")));
      }
      state = state.set("animdisplayDuration", changeTimelineDisplayDuration(action.newslide.duration,state.get("animTimeScaleZoom")) );
    }
    else if(action.slideIndex <= state.get("selectedScene")){
      state = state.set("selectedScene", state.get("selectedScene") + 1);
      state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));
    }
    state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));

    return state;

    case 'DROP_BG':
    case 'CHANGE_BG':
      if(action.data.isTrimedVideo){
        state = state.set("isBGVideoSwapinLite", true);
      }
      else {
        state = state.set("isBGVideoSwapinLite", false);
      }
      state = state.set("selectedCamera", "");
      state = state.set("selectedMedias", fromJS([]));
      if(action.data.bgType !== "BG"){
        state = state.set('visibleTimelineTab', "musicTab"); 
        state = state.set("selectedItems", fromJS([]));
       
     
        if(state.getIn(["propertyWindow", "component"]) !== "")
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      state = state.set("isCropping", false);
      state = state.set("isFraming", false);
      state = state.set("isBgCropping", false);
      state = state.set("isVideoCropping", false);
      if(state.get("visibleTimelineTab")==="musicTab" ){
          state = state.set("displayDuration", changeTimelineDisplayDuration(action.totalDuration, state.get("timeScaleZoom")));
        }
      state = state.set("bgVideoWidth", action.bgVideoWidth);
      state = state.set("bgVideoHeight", action.bgVideoHeight);
      if((state.get("anymsUploadStatus") === "processing" || action.data.isSample) && action.data.isBlob !== true){
        state = state.set("anymsUploadStatus", "completed");
       
      }
    
    return state;

      

    case "LOAD_MAIN_FOLDERS":
      state = state.setIn(["userMainFolders", "parent"], fromJS(action.parent))
      return state;

    case "LOAD_FOLDERS":
      state = state.setIn(["userFolders", "items"], OrderedMap())
      fromJS(action.data).entrySeq().forEach(([key, value]) => {
        state = state.setIn(["userFolders","items", key], value);
      });
      state = state.setIn(["userFolders","parent"], fromJS(action.parent))
      return state;




    case "DUPLICATE_SCENE":
      state = state.set('audioPlayHead', action.playHeadValue);
    return state;

    case 'DELETE_ITEM_COMPLETE':
      if (state.get("textStatus").get("id") !== null) {
        state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        state = state.update("isWorkspaceTextFocus", value => false);
      }
      var selectedItems = state.get("selectedItems");
      for (let index = 0; index < action.workspaceIds.length; index++)
      {
        var currentVal = action.workspaceIds[index];

        selectedItems = selectedItems.filter(obj =>
        {
          return obj !== currentVal;
        })
      }
      
      state = state.set("selectedItems", selectedItems);

      if(state.get("selectedItems").size === 0){
        if(state.getIn(["propertyWindow", "component"]) !== "")
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
    
     

      return state;

    case "DUPLICATE_SCENE_COMPLETE":
      if (action.currentSocketId === action.socketId){
      
        state = state.set("selectedScene", action.slideIndex);
        state = state.set("selectedScenes", fromJS([action.slideIndex]));
        state = state.set("selectedItems", fromJS([]));
      
      
        if(state.getIn(["propertyWindow", "component"]) !== "")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
        state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
        
      }else if(action.slideIndex <= state.get("selectedScene")){
        state = state.set("selectedScene", state.get("selectedScene") + 1);
        state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));
      }
      
      let newTime = action.newslide.duration + state.get("displayDuration");
     
      state = state.set("displayDuration",  changeTimelineDisplayDuration(newTime, state.get("timeScaleZoom")));
    return state;

    case "SHOW_LIBRARY":
      state = state.set("showLibrary", action.data);
    return state;
    
    case "SHOW_SLIDE_PANEL":
      state = state.set("showSlidePanel", action.data.show);
      
    return state;

    case "MOVE_SCENE_COMPLETE":
      if(action.socketId !== action.currentSocketId){
       
        if(state.get("selectedScene") === action.oldIndex)
          state = state.set("selectedScene", action.newIndex);
        else{
          if(action.oldIndex < state.get("selectedScene") && action.newIndex >= state.get("selectedScene")){
            state = state.update("selectedScene", x => x - 1);
          }
          else if(action.oldIndex > state.get("selectedScene") && action.newIndex >= state.get("selectedScene")){
            state = state.update("selectedScene", x => x + 1);
          }
        }
      }
      else{
        state = state.set("selectedScene", action.newIndex);
      }
      
      let changedConnections = state.get("connections").filter(x => { return x.get("selectedScene") === action.oldIndex});

      changedConnections.entrySeq().forEach(([key, value]) => {
        changedConnections = changedConnections.setIn([key, "selectedScene"], action.newIndex);
      })

      state = state.set("connections", state.get("connections").merge(changedConnections));
      
      state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));

    return state;

    case "MOVE_SCENE":
      state = state.set('selectedItems' , fromJS([]));
      state = state.set('selectedScenes' , fromJS([]));
      state = state.set("audioPlayHead",action.playheadVal);
    return state;

    case "SET_SELECTED_SCENE":
        
      state = state.set("selectedScene", action.data);
      state = state.set('audioPlayHead', action.playHead);
     
      state = state.update("isWorkspaceTextFocus", value => false);
      
      if(action.selectedScenes !== undefined)
        state = state.set("selectedScenes", fromJS(action.selectedScenes));
      else
        state = state.set("selectedScenes", fromJS([]));

      if(state.get("selectedItems").size > 0){
        state = state.set("selectedItems", fromJS([]));
      
      
        if(state.getIn(["propertyWindow", "component"]) !== "")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
      }
      if(state.get("isCropping"))
        state = state.set("isCropping", false);
      if(state.get("isFraming"))
        state = state.set("isFraming", false);
      if(state.get("isBgCropping"))
        state = state.set("isBgCropping", false);
      if(state.get("isVideoCropping"))
        state = state.set("isVideoCropping", false);
        
      if(state.get("selectedCamera")!==""){
        state = state.set("selectedCamera", "");
      }
      state = state.set("animdisplayDuration", changeTimelineDisplayDuration(action.newduration, state.get("animTimeScaleZoom")) );
    return state;

    case "REMOVE_SCENE":
      state = state.set('audioPlayHead', action.newPlayheadVaue); 
        state = state.set("animdisplayDuration", changeTimelineDisplayDuration(action.selectedSceneDuration, state.get("animTimeScaleZoom")));  
        state = state.set("displayDuration",  changeTimelineDisplayDuration(action.totalDuration, state.get("timeScaleZoom")) );
    return state;
      
    case "REMOVE_SCENE_COMPLETE":
      if (action.currentSocketId === action.socketId || action.slideIndex === state.get("selectedScene")){
        state = state.set("selectedScene", (action.slideIndex === 0)?0:action.slideIndex <= state.get("selectedScene")?state.get("selectedScene") - 1:state.get("selectedScene"));
        if(state.get("selectedCamera")!==""){
          state = state.set("selectedCamera", "");
        }
        if(state.get("selectedItems").size > 0){
          state = state.set("selectedItems", fromJS([]));
          state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
        }
        if(state.getIn(["propertyWindow", "component"]) !== "")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
     
      }
      else if(action.slideIndex <= state.get("selectedScene")){
        state = state.set("selectedScene", (state.get("selectedScene") === 0)?0:state.get("selectedScene") - 1);
      }
      state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));
      state = state.set('selectedMedias', fromJS([]));
      

      return state;

    case "APP_LOADED":
      state = state.set('firstLoad', false);
      return state;
      
    case "ADD_OBJECT_COMPLETE":
      if(action.socketId === action.currentSocketId){
        if(action.workspaceIds.length > 0){
          state = state.set("selectedItems", fromJS(action.workspaceIds));
          
          if(action.workspaceData.length === 1){
            let addedItem = action.workspaceData[0];
            if (addedItem.type === "CHR") {
                state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({ component: "action", isOpened: true, type: addedItem.type, "subWindow": "" })));
                state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
                state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
            }else{
              state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "settings", isOpened : true, "subWindow" : "", type : addedItem.type})));
              state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
              state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
            }
          }
        }
       
        if(state.get("swapDetails") !== null && state.get("swapDetails").isSwitch && !action.workspaceData[0].isSwitch){
          state = state.set("swapDetails", null);
        }
       
      
        
        if(state.get("currentPosition") !== null)
          state = state.set("currentPosition", null);
        
        if(state.get("selectedCamera") !== "")
          state = state.set("selectedCamera", "");
  
          state = state.set('visibleTimelineTab', "objectTab"); 
        state = state.set("isCropping", false);
        state = state.set("isFraming", false);
        state = state.set("isBgCropping", false);
        state = state.set("isVideoCropping", false);
  
        if(state.getIn(["textStatus", "id"]) !== undefined && state.getIn(["textStatus", "id"]) !== null)
          state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
      }

      var allTextItems = fromJS(action.workspaceData).filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"});
      allTextItems = allTextItems.merge(fromJS(action.workspaceChildData).filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"}));
      
      var loadedFonts = state.getIn(["loadedFonts", "fonts"]);
      if(allTextItems.size > 0){
        allTextItems.entrySeq().forEach(([key, value]) => {
          var textData = value.get("textData");
        
          if(loadedFonts.find(x => x.get("load") === textData.getIn(["formats", "containerStyle", "fontFamily"])) === undefined && textData.getIn(["formats", "others", "family"]) !== undefined){
            loadedFonts = loadedFonts.push(fromJS({font : textData.getIn(["formats", "others", "family"]), load : textData.getIn(["formats", "containerStyle", "fontFamily"]), byUser : textData.getIn(["formats", "others", "isUserFont"]) === true, isLoaded : false, url :textData.getIn(["formats", "others", "cssUrl"]) }));
          }
        });
        if(!state.getIn(["loadedFonts", "fonts"]).equals(loadedFonts)){
          state = state.setIn(["loadedFonts", "fonts"], loadedFonts);
          if(action.workspaceData.length===1){
            let addedObj = action.workspaceData[0];
            if(addedObj.type==='GROUP'&&addedObj.subType==='TXTGRP')
              state=state.set('isfontLoadedTxtGrp',true);
          }
        }
      }

    return state;

    case "SET_LABEL_VALUES":
      state = state.setIn(["labelData"], fromJS(action.data))
    return state

    case "SET_PLAY":
      if (state.get('isPlayAll')) {
        if (state.get('t1') !== null) {
          state.get('t1').kill();
          state.get('t1').eventCallback("onComplete", null);
          state.get('t1').eventCallback("onUpdate", null);
          state.get('t1').eventCallback("onStart", null);
          state.get('t1').clear();
          state = state.set('t1', null);
        }
        state = state.set("isTweening", false)

        state = state.set('visibleTimelineTab', state.get('oldTimelineTab'))
        state = state.set('isPlayAll', false);
      }

      if(!action.data)
      {
      state = state.set('isPlayerTweenComplete', false);
      state = state.set('isWsTweenComplete', false);
      state = state.set('isLoaded', false);
      }

      state = state.set('selectedItems', fromJS([]));

      if(state.get("fromStart"))
        state = state.set("fromStart", false);

      if(state.getIn(["propertyWindow", "component"]) !== "")
      {
        state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
      }
    
      state = state.set('isPlay', action.data);
      state = state.set('tweenCount', 0);
      state = state.set('loadCount', 0);
        state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({ component: "", isOpened: false })));
      if (action.data) {
        state = state.set('t1', new TimelineMax({ paused: true }));
        state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        state = state.update("isWorkspaceTextFocus", value => false);
        state = state.set("selectedMedias", fromJS([]));
        state = state.set("isTweening", true)
        state = state.set('selectedCamera', "");

        if(action.data === false && state.get("toolPreviewStarted"))
          state = state.set("toolPreviewStarted", false);
      }
      else {
        if (state.get('t1') !== null) {
          state.get('t1').kill();
          state.get('t1').eventCallback("onComplete", null);
          state.get('t1').eventCallback("onUpdate", null);
          state.get('t1').eventCallback("onStart", null);
          state.get('t1').clear();
          state = state.set('t1', null);
        }
        state = state.set("isTweening", false)
        
      }
      state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor")));
      
      return state;

    case 'SET_PLAY_ALL':

      if(!action.data)
      {
      state = state.set('isPlayerTweenComplete', false);
      state = state.set('isWsTweenComplete', false);
      state = state.set('isLoaded', false);
      }
      
      state = state.set('selectedItems', fromJS([]));
      state = state.set('selectedCamera', "");
      state = state.set('isPlayAll', action.data);
      
      if(action.fromStart===true){
        state = state.set("tempPlayhead", state.get('audioPlayHead'));
        state = state.set('audioPlayHead', 0);
       
        if((parseInt(state.get("isUserActive")) === 0) && action.data === true){
            state = state.set("toolPreviewStarted", true);
        }
      }
      if(action.data === false && state.get("toolPreviewStarted"))
        state = state.set("toolPreviewStarted", false);
      
      if(action.fromStart===false || (state.get('fromStart') && action.fromStart === undefined) ){
        state = state.set('audioPlayHead',  state.get("tempPlayhead"));
      }
      if(state.get('isPlay'))
        state = state.set('isPlay', false);
      state = state.set('tweenCount', 0);
      state = state.set('loadCount', 0);
      
        state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "", isOpened : false})));
      if(action.fromStart !== undefined)
        state = state.set("fromStart", action.fromStart);
      else if(state.get("fromStart"))
        state = state.set("fromStart", false);

      if (action.data) {
      
        state = state.set('t1', new TimelineMax({ paused: true }));
        state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        state = state.update("isWorkspaceTextFocus", value => false);
        state = state.set("selectedMedias", fromJS([]));
        state = state.set("isTweening", true)

        state = state.set('oldTimelineTab', state.get('visibleTimelineTab'))
        state = state.set('visibleTimelineTab', "musicTab")
      }
      else {
        if (state.get('t1') !== null) {
          state.get('t1').kill();
          state.get('t1').eventCallback("onComplete", null);
          state.get('t1').eventCallback("onUpdate", null);
          state.get('t1').eventCallback("onStart", null);
          state.get('t1').clear();
          state = state.set('t1', null);
        }
        state = state.set("isTweening", false)

        state = state.set('visibleTimelineTab', state.get('oldTimelineTab'))
      }
      // state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor")));
    return state;

    
    case "SET_ISSHAPEINGRP":
      state = state.set("isShapeInGrp",action.data);
      return state;

  
   
    
    
    case "UPDATE_TEXT_STATUS":
      

          if (action.data.isFocused){
            state = state.update("isWorkspaceTextFocus", value => true);
            state = state.setIn(["propertyWindow", "component"], "settings").setIn(["propertyWindow", "isOpened"], true);
            state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
            state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
          }else if(state.getIn(["textStatus", "isFocused"]) && action.data.isFocused === false && !action.data.isSelected){
            state = state.update("isWorkspaceTextFocus", value => false);
            if(state.getIn(["propertyWindow", "component"]) === "settings")
            {
              state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
              state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
              state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
            }
          }else{
            state = state.update("isWorkspaceTextFocus", value => false);
          }
          state = state.set("currentPosition", null);
          state = state.set("textStatus", state.get("textStatus").merge(fromJS(action.data)));
      
      
      return state;

    case "SET_TEXT_OPTIONS":
    
      var textOptions = state.get("textOptions");
     
      for (var key in action.data) {
        let property = key, value = action.data[key];

        if (property !== "isBullet") {
          if (property !== "colors") {
            if (property === "unlink") {
              value = null; property = "link";
            }
            var isActive = value !== null && value !== "normal";
            if (property === "bullet"){
              isActive = textOptions.getIn(["bullet", "isActive"]);
            }
            textOptions = textOptions.setIn([property, "value"], value).setIn([property, "isActive"], isActive);
          }
          else {
            textOptions = textOptions.set("colors", fromJS(value));
          }
        }
        else {
          textOptions = textOptions.setIn(["bullet", "isActive"], value);
        }
      }
     
      if (!state.get("textOptions").equals(textOptions))
        state = state.set("textOptions", textOptions);

    return state;


    case "CHANGE_TEXT":
     
      if(action.data.settings !== undefined){
        if(action.data.settings.property !== "isBullet"){
          let property =  action.data.settings.property, value = action.data.settings.value;
          if(property === "fontSize")
            value = (value !== null)?parseFloat(value, 10):null;
          if(property === "unlink"){
            value = null; property = "link";
          }
          isActive = value !== null;

          if(property === "bullet")
            isActive = state.getIn(["textOptions", "bullet", "isActive"]);
          
          state = state.setIn(["textOptions", property, "value"], value).setIn(["textOptions", property, "isActive"], isActive);

          if(property === "color")
            state = state.setIn(["textOptions", "colors"], fromJS([]));
          
        }
        else{

          state = state.setIn(["textOptions", "bullet", "isActive"], action.data.settings.value);
        }
        if(state.getIn(["textStatus", "selectedAll"]))
          state = state.setIn(["textStatus", "selectedAll"], false);
       
      }
    return state;

    case "UPDATE_TEXT":
      if(action.data.isGrouped){
        state = state.set("textUpdated", 0);
      }

      textOptions = state.get("textOptions");
     
      if(action.data.property !== "isBullet"){
        let value = action.data.value, property =  action.data.property;
        if(action.data.property === "fontSize")
          value = value !== null?parseFloat(value, 10):null;
        if(action.data.property === "letterSpacing")
          value = value !== null?parseFloat(value, 10):null;
       
        isActive = value !== null;
        if(property === "bullet"){
          isActive = state.getIn(["textOptions", "bullet", "isActive"]);
         
          if(state.getIn(["textOptions", "textAlign", "value"])  !== "left")
            state = state.setIn(["textOptions", "textAlign", "value"], "left");
        }
        
        state = state.setIn(["textOptions", property, "value"], value).setIn(["textOptions", property, "isActive"], isActive);
        if(property === "fontFamily" && action.data.textData !== undefined){
          state = state.setIn(["textOptions", "fontFamily", "value"], value);
          if(action.data.fontLoaded === true){
            var loadedFonts = state.getIn(["loadedFonts", "fonts"]);
            let loadedFont = loadedFonts.find(x => x.get("load") === value);
            
            if(loadedFont === undefined){
              if(action.data.family !== undefined)
                state = state.setIn(["loadedFonts", "fonts"], loadedFonts.push(fromJS({font : action.data.family, load : value, byUser : action.data.textData.getIn(["formats","others","isUserFont"]), isLoaded : true, url : action.data.textData.getIn(["formats","others","cssUrl"]) })));
                state = state.setIn(["loadedFonts", "fontTracking", action.data.id], true);
            }else if(loadedFont.get("isLoaded") === false){
                let fontIndex = loadedFonts.findIndex(x => x.get("load") === value);
                state = state.setIn(["loadedFonts", "fontTracking", action.data.id], true);
                state = state.setIn(["loadedFonts", "fonts", fontIndex, "isLoaded"], true);
            }
          }
        }
      }
      else{
        state = state.setIn(["textOptions", "bullet", "isActive"], action.data.value);
      }
      let selectedAll = false;
     
      if(action.data.selectedAll !== undefined && action.data.selectedAll && state.getIn(["textStatus", "isFocused"]))
        selectedAll = true;
     
      if(state.getIn(["textStatus", "selectedAll"]) !== selectedAll){
        state = state.setIn(["textStatus", "selectedAll"], selectedAll);
      }

    return state;

    case "UPDATE_GROUP_TEXT":
      if(action.data.propertyUpdate){
        let value = action.data.value, property =  action.data.property;
        if(action.data.property === "fontSize")
          value = value !== null?parseFloat(value, 10):null;
        if(action.data.property === "letterSpacing")
          value = value !== null?parseFloat(value, 10):null;
       
        isActive = value !== null;
        if(property === "bullet"){
          isActive = state.getIn(["textOptions", "bullet", "isActive"]);
         
          if(state.getIn(["textOptions", "textAlign", "value"])  !== "left")
            state = state.setIn(["textOptions", "textAlign", "value"], "left");
        }
        state = state.setIn(["textOptions", property, "value"], value).setIn(["textOptions", property, "isActive"], isActive);
        let selectedAll = false;
     
        if(action.data.selectedAll !== undefined && action.data.selectedAll && state.getIn(["textStatus", "isFocused"]))
          selectedAll = true;
      
        if(state.getIn(["textStatus", "selectedAll"]) !== selectedAll){
          state = state.setIn(["textStatus", "selectedAll"], selectedAll);
        }
      }
    return state;

    case "UPDATE_TEXT_COMPLETE":
        if(action.formats.containerStyle.fontFamily !== undefined){
         
          var loadedFonts = state.getIn(["loadedFonts", "fonts"]);
          if(loadedFonts.find(x => x.get("load") === action.formats.containerStyle.fontFamily) === undefined && action.formats.others.family !== undefined){
            state = state.setIn(["loadedFonts", "fonts"], loadedFonts.push(fromJS({font : action.formats.others.family, load : action.formats.containerStyle.fontFamily, byUser : action.formats.others.isUserFont, isLoaded : false, url : action.formats.others.cssUrl })));
          }
        }
    return state;

    case "UPDATE_OBJECT_COMPLETE":
     
      if(action.toUpdate.textData !== undefined && action.toUpdate.textData.formats.containerStyle.fontFamily !== undefined && action.toUpdate.textData.formats.others.family !== undefined){
        var loadedFonts = state.getIn(["loadedFonts", "fonts"]);
        if(loadedFonts.find(x => x.get("load") === action.toUpdate.textData.formats.containerStyle.fontFamily) === undefined && action.toUpdate.textData.formats.others.family !== undefined){
          state = state.setIn(["loadedFonts", "fonts"], loadedFonts.push(fromJS({font : action.toUpdate.textData.formats.others.family, load : action.toUpdate.textData.formats.containerStyle.fontFamily, byUser : action.toUpdate.textData.formats.others.isUserFont, isLoaded : false, url : action.toUpdate.textData.formats.others.cssUrl, id : action.selectedItem })));
          
          state = state.setIn(["loadedFonts", "fontTracking", action.selectedItem], false);
        }
      }
    return state;

    case "SET_SELECTED_ITEMS":

      state = state.set("selectedItems", fromJS(action.data.selectedItems));
      if( state.getIn(['propertyWindow','type'])!=='ANIM'){
      state=state.setIn(['propertyWindow','type'],action.data.type);
      state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
      state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      state = state.update("isWorkspaceTextFocus", value => false);
      state = state.set('selectedKeyframe', '');
     
      if(action.data.currentPosition !== undefined)
        state = state.set("currentPosition", fromJS(action.data.currentPosition));
      else 
        state = state.set("currentPosition", null);
        
      state = state.set("selectedCamera", "");
      if (action.data.selectedItems.length > 0) {
        state = state.set("visibleTimelineTab", "objectTab");
      if(action.selectedSceneDuration){
        state = state.set("animdisplayDuration", changeTimelineDisplayDuration(action.selectedSceneDuration, state.get("animTimeScaleZoom")) );
      } 
      }
      if (state.getIn(["textStatus", "id"]) !== null)
        state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        
      state = state.set("isCropping", false);
      state = state.set("isFraming", false);
      state = state.set("isBgCropping", false);
      state = state.set("isVideoCropping", false);

      if((action.data.selectedItems.length === 1 && state.get("swapDetails") !== null && action.data.selectedItems[0] !== state.get("swapDetails").id) || action.data.selectedItems.length !== 1){
        state = state.set('swapDetails', null);
        document.getElementById("app-overlay").style.display = "none";
      }

      
      if(action.data.selectedItems.length === null){
        state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "", isOpened : false,type:action.data.type})));
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      

      if (state.getIn(["transformStatus", "transforming"]))
        state = state.set("transformStatus", fromJS({ transforming: false, moving: false, resizing: false, rotating: false }));
      
      if(state.get("selectedScenes").size > 1)
        state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));
      if(state.getIn(['propertyWindow','type'])!=='ANIM'){
      if(action.data.selectedItems.length === 1){
        if(action.data.type === "CHR"){
                 
         
          if((state.get("swapDetails") === null && state.getIn(['propertyWindow','isOpened'])===false)||(state.get("swapDetails") === null&&state.getIn(['propertyWindow','isOpened'])===true&&state.getIn(['propertyWindow','component'])=='bgColor')){           
            state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "action", isOpened : true, "subWindow" : "", type: action.data.type})));
            state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
            state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
          }
        }else{
          state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "settings", isOpened : true, "subWindow" : "", type: action.data.type})));
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
      }
      else{ 
        state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "", isOpened : false})));
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
    }
      
    return state;

    case "TOGGLE_CROP":
      if(state.get("currentPosition") !== null)
        state = state.set("currentPosition", null);
      var currentZoom = getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"));
      if(currentZoom < state.get("zoomFactor"))
        state = state.set("zoomFactor", currentZoom);
    return state.update("isCropping", value => !value);

    case "TOGGLE_FRAME":
      return state.update("isFraming", value => !value);

    case "TOGGLE_BG_CROP":
          var currentZoom = getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"));
          if(currentZoom < state.get("zoomFactor"))
            state = state.set("zoomFactor", currentZoom);
          state = state.update("isBgCropping", value => !value);
        
    return state;
    
    case "UPDATE_TRANSFORM_STATUS":
      state = state.set("transformStatus", state.get("transformStatus").merge(fromJS(action.data)));
      return state;

    case "START_PLAY":
      if (action.data === "player")
        state = state.set("isPlayerTweenComplete", true)
      if (action.data === "workspace")
        state = state.set("isWsTweenComplete", true)

        
      if (state.get("isPlayerTweenComplete") && state.get("isWsTweenComplete") && !state.get("isLoaded") ) {
        state = state.set("isLoaded", true)
        if (state.get("isPlay"))
          state.get('t1').play();
        else
        {
          const startTime = state.getIn(['labelData','sceneStartTime',`${state.get('currentSceneNumber')}`])
          state.get('t1').play(startTime);
        }   
      }
      return state;

      case 'SET_PLAYER_POSITION':
        if(state.get('isPlayAll'))
        {   
          if(action.data === 'Prev'){
          if(state.get('t1').currentLabel()!==null) {
            state.get('t1').play((parseInt(state.get('t1').currentLabel()) -1).toString(),false);
          }
        }
        else{
          if(state.get('t1').currentLabel()<state.get('t1').getLabelsArray().length)
          {
          state.get('t1').play((parseInt(state.get('t1').currentLabel() === null ? 0 : state.get('t1').currentLabel()) +1).toString(),false);
          }
          }
        }
        return state;

        case 'ADD_SLIDELABEL_DATA':
              if(action.data==='')
              state=state.setIn(['slideLabelData'],fromJS([]));
              else 
              state=state.setIn(['slideLabelData'],fromJS(action.data));
        return state;

        case 'SET_SLIDE_JUMP':
            let slideLabelList=state.getIn(['slideLabelData']);
            if (state.get('isPlayAll')) {

              slideLabelList.entrySeq().forEach(([key, value]) => {
                if (action.data - 1 === 0)
                  state.get('t1').play((parseInt(0)).toString(), false);

                if (parseInt(action.data - 1) === value.get('slide')) {
                  state.get('t1').play((parseInt(value.get('label'))).toString(), false);

                }
              });
            }

        return state;


        case 'SET_SCENE_POSITION':
          if(state.get('isPlayAll'))
          {
            state = state.set('currentScene',action.data);
            state = state.set('currentSceneNumber',action.currentSceneNumber);
            state = state.set('selectedScene',action.currentSceneNumber);
            state = state.set('currentSceneStartTime',action.currentSceneStartTime);
            state = state.set('currentSceneDuration',action.currentSceneDuration);
          }
          else if(state.get('isPreview')){
            state = state.set('currentScene',action.data);
            state = state.set('currentSceneNumber',action.currentSceneNumber);
            state = state.set('selectedScene',action.currentSceneNumber)
          }

          
          return state;
  
      case "ADD_TWEEN":
        if (action.tweenType === "addchartween") 
        {
          var tweenDuration = action.data.endTime - action.data.startTime
          var isRepeated = 1//(action.data.isRepeated === "0") ? 0 : -1;
          
          if (action.data.type === "PROP" && action.data.isAnimated)
          {
            isRepeated = (action.data.repeatLoop === 0) ? -1 : action.data.repeatLoop - 1;
          }
            
          if(action.data.type === "SCREEN")
           isRepeated = 0;
          // const timelineEaseName = action.data.timeline.length ?
          //   action.data.timeline.filter(val => (typeof val.toVal.ease === "string")).map(val => val.toVal.ease)
          //   : [];
          var chart = new TimelineMax({ repeat: isRepeated , paused: true});
          for (var i = 0; i < action.data.timeline.length; i++) {
            chart.add(TweenMax.to(action.data.timeline[i].domVal, action.data.timeline[i].duration, action.data.timeline[i].toVal), action.data.timeline[i].time)
          }

          // state.get('t1').add(chart, action.data.startTime)

          state.get('t1').addCallback(function(chartimeline){
            chartimeline.play(0);
          },state.getIn(["labelData", action.data.idVal, "enterStart"]).toString(), [chart] );


          if(action.data.type === "SCREEN"){
            state.get('t1').add(TweenMax.fromTo(document.getElementById(action.data.idVal), 0.001, { autoAlpha: 0 },{ autoAlpha: 1 }), (state.getIn(["labelData", action.data.idVal, "enterStart"])).toString())
          state.get('t1').add(TweenMax.to(document.getElementById(action.data.idVal), 0.001, { autoAlpha: 0 }), (state.getIn(["labelData", action.data.idVal, "enterStart"]) + 0.9).toString())
          }

          // var mouthtimeline = new TimelineMax({ paused: true, repeat: -1 });
          // for (i = 0; i < action.data.mouthValues.length; i++) {
          //   mouthtimeline.add(TweenMax.to(action.data.mouthValues[i].domVal, action.data.mouthValues[i].duration, action.data.mouthValues[i].toVal), action.data.mouthValues[i].time)
          // }

          // for (var m = 0; m < action.data.voiceData.length; m++) 
          // {
          //   for (var jj = 0; jj < action.data.voiceData[m].length-1; jj++) {
          //     var time = parseFloat(action.data.voiceData[m][jj].split(",")[0]) - action.data.lipSyncStart[m]
          //     var decibal = (time <0)?0:action.data.voiceData[m][jj].split(",")[1]
          //     if(jj === action.data.voiceData[m].length-2)
          //       decibal = 0;

          //     if(time > action.data.playStart[m]) 
          //     {
          //       state.get('t1').addCallback(function (t1, pauseVal) {
          //         t1.pause(pauseVal);
          //       }
          //       , time, [mouthtimeline, decibal])
          //     }
          //   }
          // }

        }
        else if (action.tweenType === "fromTo") 
            state.get('t1').add(TweenMax.fromTo(action.data.playerDOM, action.data.startTime, action.data.fromVal, action.data.toVal), action.data.time)
        else if (action.tweenType === "addCallback") 
          state.get('t1').addCallback(action.data.callBack, action.data.startTime, action.data.dataArr)
        else if (action.tweenType === "eventCallback")
          state.get('t1').eventCallback("onUpdate", action.data.callBack);
        else if (action.tweenType === "onStart") {
          state.get('t1').eventCallback("onStart", action.data.callBack);

        }
        else if (action.tweenType === "from")
          state.get('t1').add(TweenMax.from(action.data.playerDOM, action.data.startTime, action.data.fromVal), action.data.time)
        else if (action.tweenType === "to")
          state.get('t1').add(TweenMax.to(action.data.playerDOM, action.data.startTime, action.data.toVal), action.data.time)
        else if (action.tweenType === "staggerFromTo")
          state.get('t1').add(TweenMax.staggerFromTo(action.data.playerDOM, action.data.startTime, action.data.fromVal, action.data.toVal, action.data.staggerTime), action.data.time)
        else if (action.tweenType === "staggerTo")
          state.get('t1').staggerTo(action.data.playerDOM, action.data.startTime, action.data.toVal, action.data.staggerTime, action.data.time)
        else if (action.tweenType === "staggerFrom")
          state.get('t1').staggerFrom(action.data.playerDOM, action.data.startTime, action.data.fromVal, action.data.staggerTime, action.data.time, action.data.onComplete)
        else if (action.tweenType === "set") {
          if(action.data.setType === "styles")
            state.get('t1').add(TweenMax.set(action.data.playerDOM, action.data.setVal));
          else
            state.get('t1').set({}, {}, action.data.time);
        }
      return state;


    case "CHANGE_PLAYTIME":
      state = state.set('playTime', action.data);
      return state;

    case "MOVE_UPDATE":
      state.set("transformStatus", fromJS({ transforming: false, moving: false, resizing: false, rotating: false }));
      if(state.get("currentPosition") !== null)
        state = state.set("currentPosition", null);

    return state;

    case "MOVE_UPDATE_COMPLETE":
      if(state.get("undoResize"))
        state = state.set("undoResie", false);
      return state.set("transformStatus", fromJS({ transforming: false, moving: false, resizing: false, rotating: false }));
    case "RESIZE_UPDATE":
    case "ROTATION_UPDATE":
      if(!state.get("undoResize"))
        state = state.set("undoResie", true);
      return state.set("transformStatus", fromJS({ transforming: false, moving: false, resizing: false, rotating: false }));

    case 'DELETE_ITEM':
      if (state.get("textStatus").get("id") !== null) {
        state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        state = state.update("isWorkspaceTextFocus", value => false);
      }

      if(state.getIn(["propertyWindow", "component"]) !== "")
      {
        state = state.setIn(["propertyWindow", "component"], "");
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      if(state.get("swapDetails") !== null){
        state = state.set("swapDetails", null);
      }
      state = state.set("selectedItems", fromJS([]));
     
     
      state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
      if(state.getIn(["propertyWindow", "component"]) !== "")
      {
        state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      state = state.set("multiEffect", []);
      return state;

    case "CHANGE_TIMELINE_TAB_NAME":
      state = state.set('selectedItems', fromJS([]))
      state = state.set('visibleTimelineTab', action.tabName);
      state = state.set("selectedMedias", fromJS([]));
      state = state.set("BGDrop", "");
      
     
        state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));

      if (action.globalStart && action.tabName === "musicTab")
        state = state.set('audioPlayHead', action.globalStart);
      if(action.tabName === "cameraTab")
        state = state.set('selectedCamera', action.staticCam);
      
      if(action.tabName !== "cameraTab" && state.get("selectedCamera") !== "")
        state = state.set("selectedCamera", "");
      if(action.tabName!=="musicTab" && action.tabName!=="bgColorTab" && action.duration){

        let newDisplayDuration = action.duration-action.duration*state.get("animTimeScaleZoom")/100;
        state = state.set("animdisplayDuration", parseInt(newDisplayDuration, 10) < 1 ? 1 : newDisplayDuration);
      }
      else{
        if(action.duration){
          let newDisplayDuration = action.duration-action.duration*state.get("timeScaleZoom")/100;
          state = state.set("displayDuration", parseInt(newDisplayDuration, 10) < 1 ? 1 : newDisplayDuration);
        }
        
      }
      return state;

    case "UPDATE_TIMELINE_DRAG":

      if (action.item === "workspaceItems") {
        for (let itr = 0; itr < action.data.length; itr++) {
          if (action.data[itr].name === 'duration')
          {
            state = state.set("selectedCamera", "");
            state = state.set("selectedItems", fromJS([]));
            state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
           
           
            if(state.getIn(["propertyWindow", "component"]) !== "")
            {
              state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
              state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
              state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
            }
              state = state.set("selectedMedias", fromJS([]));
          }
        }
        if(action.nextDuration)
          state = state.set("displayDuration", changeTimelineDisplayDuration( action.nextDuration,state.get("timeScaleZoom")) );
      }
    return state;

      case "UPDATE_TIMELINE_DRAG_COMPLETE":
      let itr = 0;
      let isBackTrim = false;
      if (action.itemData === "workspaceItems") {
        for (itr = 0; itr < action.actionData.length; itr++) {
          if(action.actionData[itr].name==="videoEnd")
                isBackTrim = true;
          
          if (action.actionData[itr].name==='duration' &&  action.actionData[itr].value<state.get('audioPlayHead'))
          {
            if(isBackTrim)
              state = state.set('audioPlayHead',action.actionData[itr].sceneStartTime+ action.actionData[itr].value); 
            else 
              state =state.set('audioPlayHead',action.actionData[itr].sceneStartTime);

          }
        }

      }
      return state;
    if(action.category ===  "VIDEO")
    {
      state = state.set("selectedScene", action.id[0]);
      state = state.set("selectedScenes", fromJS([action.id[0]]));
      state = state.set('audioPlayHead', action.time);
      
    }
      if (state.get("selectedItems").size > 0){
        state = state.set("selectedItems", fromJS([]));
      
        
        if(state.getIn(["propertyWindow", "component"]) !== "")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
        state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
      }
      if (state.getIn(["propertyWindow", "component"]) !== "")
      {
        state = state.setIn(["propertyWindow", "component"], "");
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      }
      state = state.update("isWorkspaceTextFocus", value => false);
      state = state.update("selectedMedias", value => fromJS(action.id));
      return state;

 
    
    case "DELETE_VIDEO":
      return state.set("selectedMedias", fromJS([]));

    case "SET_WORKSPACE_TEXT_FOCUS":
      if (state.getIn(["textStatus", "isFocused"]))
        state = state.update("isWorkspaceTextFocus", value => true);
      else
        state = state.update("isWorkspaceTextFocus", value => action.value);
      return state;

    case 'SET_MUSIC_DATA':
      state = state.set('musicData', fromJS(action.data));
      return state;

    case "SET_ZOOM":
      if(action.data.zoomFactor !== undefined)
        state = state.set("zoomFactor", action.data.zoomFactor);
      if(action.data.workspaceBounds !== undefined)
        state = state.set("workspaceBounds", state.get("workspaceBounds").merge(fromJS(action.data.workspaceBounds)));
      if(action.data.fromUser !== undefined && action.data.fromUser){
        state = state.setIn(["workspaceStage", "isLocked"], true);
      }
      if(state.get("zoomFactor") < 0.01)
        state = state.set("zoomFactor", 0.01);
    return state;


    case "CHANGE_BG_COMPLETE":
    case "DROP_BG_COMPLETE":
      if(action.socketId !== action.currentSocketId && action.deleteId !== ""){
        state = state.set("selectedItems", fromJS([]));
       
       
        if(state.getIn(["propertyWindow", "component"]) !== "")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
        state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
        state = state.set("multiEffect", []);
      }
    return state;

    case "CROP_BG":
      state = state.set("transformStatus", fromJS({transforming : false, moving : false, resizing : false, rotating : false}));
      state = state.set("isVideoCropping", false);
    return state.set("isBgCropping", false);

    case "TOGGLE_VIDEO_CROP":
      state = state.set("cropVideoId", action.id);
    return state.update("isVideoCropping", value => !value);

    case "TOGGLE_CROP":
    return state.update("isCropping", value => !value);
    
    case "TOGGLE_FRAME":
    return state.update("isFraming", value => !value);
    
    case "CROP_IMAGE":
      state = state.set("transformStatus", fromJS({transforming : false, moving : false, resizing : false, rotating : false}));
      state = state.set("isCropping", false);
      state = state.set("isFraming", false);
      if(state.get("currentPosition") !== null)
        state = state.set("currentPosition", null);
    return state;

    case "TOGGLE_GRID":
    return state.update("workspaceGrid", value => !value);

    case 'SWAP_ITEM_UNDO':
      state=state.set("undoProp",action.data);
    return state;
    case 'SWAP_ITEM':

      state = state.set("textStatus", fromJS({id: null, isSelected : false, isFocused : false, container : null, isRTL : false, isGrouped : false, fontSize : null}));
      state = state.update("isWorkspaceTextFocus", value => false);
      state = state.set('visibleTimelineTab', "objectTab");
      state = state.set("swapDetails", action.data !== "" ? action.data : null);
      
      if(action.data.libType !== undefined){
        state.set('innerActiveTab', action.data.libType);
      }
      if(action.data.isBG)
        state = state.set("BGDrop", action.data.libType);
      else if(action.data === "")
        state = state.set("BGDrop", "");
      
    return state;

    case "COPY_ITEM_TYPE":
      
      state = state.set('copiedItem', action.data);
      
    return state;

    case "COPY_OBJECTS":
      return state.update("isCopyObject", value => action.value);
    
    case "CUT_OBJECTS":
      return state.update("isCutObject", value => action.value);
    
    case "PASTE_OBJECTS":
      if(action.value === false)
        state = state.update("selectedMedias", value => fromJS([]));
      if(state.get("currentPosition") !== null)
        state = state.set("currentPosition", null);
      
    return state.update("isPasteObject", value => action.value);

    case "PASTE_ITEMS_COMPLETE":
      if(action.currentSocketId === action.socketId || action.selectedScene === state.get("selectedScene")){
        if(action.currentSocketId === action.socketId){
          if(state.get("currentPosition") !== null)
            state = state.set("currentPosition", null);
          
          state = state.set('visibleTimelineTab', "objectTab"); 
          state = state.set('selectedCamera', ""); 
          state = state.set("selectedItems", fromJS(action.workspaceIds));
        }
      }
      var allTextItems = fromJS(action.workspaceData).filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"});
      allTextItems = allTextItems.merge(fromJS(action.workspaceChildData).filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"}));
    
      var loadedFonts = state.getIn(["loadedFonts", "fonts"]);
      if(allTextItems.size > 0){
        allTextItems.entrySeq().forEach(([key, value]) => {
          var textData = value.get("textData");
        
          if(loadedFonts.find(x => x.get("load") === textData.getIn(["formats", "containerStyle", "fontFamily"])) === undefined && textData.getIn(["formats", "others", "family"]) !== undefined){
            loadedFonts = loadedFonts.push(fromJS({font : textData.getIn(["formats", "others", "family"]), load : textData.getIn(["formats", "containerStyle", "fontFamily"]), byUser : textData.getIn(["formats", "others", "isUserFont"]) === true, isLoaded : false, url :textData.getIn(["formats", "others", "cssUrl"]) }));
          }
        });
        if(!state.getIn(["loadedFonts", "fonts"]).equals(loadedFonts)){
          state = state.setIn(["loadedFonts", "fonts"], loadedFonts);
        }
      }
    return state;

    case "PASTE_SCENES_COMPLETE":
     
      var loadedFonts = state.getIn(["loadedFonts", "fonts"]);
      for(var i = 0; i < action.scenes.length; i++ ){
        var scene = fromJS(action.scenes[i]);
       if(typeof scene === "object"){
        var allTextItems = scene.get("workspaceItems").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"});
        allTextItems = allTextItems.merge(scene.get("workspaceChildren").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"}));
        
        if(allTextItems.size > 0){
          allTextItems.entrySeq().forEach(([key, value]) => {
            var textData = value.get("textData");
            if(loadedFonts.find(x => x.get("load") === textData.getIn(["formats", "containerStyle", "fontFamily"])) === undefined && textData.getIn(["formats", "others", "family"]) !== undefined){
              loadedFonts = loadedFonts.push(fromJS({font : textData.getIn(["formats", "others", "family"]), load : textData.getIn(["formats", "containerStyle", "fontFamily"]), byUser : textData.getIn(["formats", "others", "isUserFont"]) === true, isLoaded : false,  url :textData.getIn(["formats", "others", "cssUrl"])}));
            }
          });
        }
      }
    }
    state = state.setIn(["loadedFonts", "fonts"], loadedFonts);
      
      
    return state;

    case "GROUP_OBJECTS_COMPLETE":
     
      if(action.currentSocketId === action.socketId || state.get("selectedItems").some(r => fromJS(action.removeIds).includes(r))){
        state = state.set("selectedItems", fromJS([Object.keys(action.workspaceItems)[0]]));
        if(state.getIn(["textStatus", "id"]) !== undefined && state.getIn(["textStatus", "id"]) !== null)
          state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "settings", isOpened : true, "subWindow" : "", type: "GROUP"})));
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        state = state.set("currentPosition", null);
      }
    return state;
    break;

    case "UNGROUP_OBJECTS_COMPLETE":
     
      if(action.currentSocketId === action.socketId || state.get("selectedItems").includes(action.removeIds[0])){
        state = state.set("selectedItems", fromJS(Object.keys(action.workspaceChildren)));
        state = state.set("propertyWindow", state.get("propertyWindow").merge(fromJS({component : "", isOpened : false})));
        state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
        state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        if(state.getIn(["textStatus", "id"]) !== undefined && state.getIn(["textStatus", "id"]) !== null)
          state = state.set("textStatus", fromJS({ id: null, isSelected: false, isFocused: false, container: null, isRTL: false, isGrouped: false, fontSize: null }));
        state = state.set("currentPosition", null);
      }else{

      }
    return state;
    break;
    
    case "SET_PROPERTY_WINDOW":
    if(action.data.subWindow === undefined){  
        state = state.setIn(["propertyWindow", "component"], action.data.component);
        state = state.setIn(["propertyWindow", "subWindow"], "");
        state = state.setIn(["propertyWindow", "type"], action.data.type);
        state = state.setIn(["propertyWindow", "isOpened"], true);
          
        if(action.data.selectedScene !== undefined){
          if(action.data.selectedScene !== state.get("selectedScene")){
            state = disableSelection(state);
          }
          state = state.set("selectedScene", action.data.selectedScene);
          state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));
        }

        if(action.data.component === ""){
          state = state.setIn(["propertyWindow", "isOpened"], false);
        }

        if(action.data.component === "transition"){
          state = disableSelection(state);
        }

        if(action.data.component === "settings" && action.data.type === "text"){
          state = state.set("textStatus", fromJS({id: null, isSelected : false, isFocused : false, container : null, isRTL : false, isGrouped : false, fontSize : null}));
        }
      }
      else if(action.data.component && action.data.component !== '' && action.data.subWindow && action.data.subWindow!==''){
        state = state.setIn(["propertyWindow", "component"], action.data.component);
        state = state.setIn(["propertyWindow", "subWindow"], action.data.subWindow);
        state = state.setIn(["propertyWindow", "type"], action.data.type);
        state = state.setIn(["propertyWindow", "isOpened"], true);
      }
      else{
        state = state.setIn(["propertyWindow", "subWindow"], action.data.subWindow);
      }
      state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
      state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
      return state;
    break;

    case "COPY_FILTER":
      if(action.subtype === "BG")
        state = state.set("clonedBgFilter",action.data);
      return state;

    case "DISPLAY_COMMON_POPUP":
      state = state.update("isWorkspaceTextFocus", value => false);
      if(action.value !== undefined && action.value !== null){
        state = state.setIn(["commonPopup", "popup"], action.value);
        state = state.setIn(["commonPopup", "show"], !state.getIn(['commonPopup', 'show']));
        
      }else{
        if(action.status !== undefined && !action.status){
          state = state.setIn(["commonPopup", "popup"], action.value);
          state = state.setIn(["commonPopup", "show"], action.status);
        }
      }
      return state;  


    case "APPLY_FILTER":
    case "UPDATE_VIDEO_DATA"  :
      state = state.setIn(["commonPopup", "popup"], '');
      state = state.setIn(["commonPopup", "show"], false);
      return state;
      
      case "FONT_UPLOADED":
        var allFonts = state.get("userFonts");
       
      return state.set("userFonts", allFonts.push(fromJS(action.data)));
      
      case "SET_USER_FONTS":
        if(action.data.length > 0)
          state = state.set("userFonts", fromJS(action.data));
      return state;

      case "SET_SHARE_DETAILS":
    
        if(action.data.addressBook !== undefined){
          state = state.set("addressBook", fromJS(action.data.addressBook));
        }

        if(action.data.sharedWith !== undefined){
          state = state.set("sharedWith", fromJS(action.data.sharedWith));
        }
       
      return state;
      
    case "SET_PREBUILT_LOAD":
      if(state.getIn(['liteChanges', 'newScene'])) 
        state = state.setIn(['liteChanges', 'newScene'], false);
      state = state.set('loadprebuilt', fromJS({load: action.data, src: action.source}));
      return state;

    case "ADD_PREBUILT":
      state = state.set("prebuiltScenes", fromJS(action.data.sceneThumbs));
    return state;

    case "ADD_PREBUILT_COMPLETE":

      if(action.currentSocketId === action.socketId || (action.addAll && action.replace) || (action.replace && action.selectedScene === state.get("selectedScene")) ){
        state = state.update("selectedMedias", value => fromJS([]));
        state = state.update("selecteCamera", value => "");
        state = state.update("selectedKeyframe", value => "");
        state = state.set("selectedItems", fromJS([]));
      
       
        if(state.getIn(["propertyWindow", "component"]) !== "")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
        state = state.set("isCropping", false).set("isFraming", false).set("isBgCropping", false);
        if(action.currentSocketId === action.socketId){
          state = state.set("selectedScene", action.selectedScene);
          state = state.set("confirmPopup", fromJS({show : false}));
        }
        if(action.addAll && action.replace)
          state = state.set("selectedScene", 0);
        
        state = state.set("selectedScenes", fromJS([state.get("selectedScene")]));
        
        state = state.set('loadprebuilt', fromJS({load: true, src: ''}));

        
      }
      let loadedFonts = state.getIn(["loadedFonts", "fonts"]);
      if(action.addAll){
        let scenes = fromJS(action.prebuiltData.project.scenes);
        state = state.set("audioPlayHead", scenes.getIn([0, "playHeadValue"]));
        for(var i = 0; i < scenes.size; i++ ){
          
          var scene = scenes.get(i);
          var allTextItems = scene.get("workspaceItems").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"});
          allTextItems = allTextItems.merge(scene.get("workspaceChildren").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"}));
          
          if(allTextItems.size > 0){
            allTextItems.entrySeq().forEach(([key, value]) => {
              var textData = value.get("textData");
              if(textData.getIn(["formats", "others", "family"]) !== undefined && loadedFonts.find(x => x.get("load") === textData.getIn(["formats", "containerStyle", "fontFamily"])) === undefined){
                loadedFonts = loadedFonts.push(fromJS({font : textData.getIn(["formats", "others", "family"]), load : textData.getIn(["formats", "containerStyle", "fontFamily"]), byUser : textData.getIn(["formats", "others", "isUserFont"]) === true, isLoaded : false,  url :textData.getIn(["formats", "others", "cssUrl"])}));
              }
            });
          }
        }
        state = state.set("displayDuration",  changeTimelineDisplayDuration(parseFloat(action.prebuiltData.project.duration.toFixed(1)), state.get("timeScaleZoom")));
      }else{
        var scene = fromJS(action.prebuiltData);

        state = state.set("animDisplayDuration", changeTimelineDisplayDuration(parseFloat(action.prebuiltData.duration.toFixed(1)), state.get("timeScaleZoom")));
        state = state.set("audioPlayHead", action.prebuiltData.duration);
       
        if (action.prebuiltData.workspaceBG.type !== "UPVIDEO" && action.prebuiltData.workspaceBG.type !== "STOCKVID")
          state = state.set("visibleTimelineTab", "objectTab");
        
        var allTextItems = scene.get("workspaceItems").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"});
        allTextItems = allTextItems.merge(scene.get("workspaceChildren").filter((value, key) => {return value.get("type") === "TEXT" || value.get("type") === "SHAPE"}));

        if(allTextItems.size > 0){
          allTextItems.entrySeq().forEach(([key, value]) => {
            var textData = value.get("textData");
            if(textData.getIn(["formats", "others", "family"]) !== undefined && loadedFonts.find(x => x.get("load") === textData.getIn(["formats", "containerStyle", "fontFamily"])) === undefined){
              loadedFonts = loadedFonts.push(fromJS({font : textData.getIn(["formats", "others", "family"]), load : textData.getIn(["formats", "containerStyle", "fontFamily"]), byUser : textData.getIn(["formats", "others", "isUserFont"]) === true, isLoaded : false,  url :textData.getIn(["formats", "others", "cssUrl"])}));
            }
          });
        }
      }
     
      state = state.setIn(["loadedFonts", "fonts"], loadedFonts);
      
    return state;

    case "TOGGLE_TOOLBAR":
        state = state.update("isToolBarExpanded", value => !value);
    return state;


    case "UPDATE_SELECTION_BOX":
     return state;
    break;
    case "SOCKET_CONNECTED":
   
    if (action.socketId !== action.currentSocketId)
      {
        let connections = state.get("connections");
        if(!connections.has(action.socketId)){
          var userItem = connections.filter(function(obj, key){ return  obj.get("userId") === action.userId });
          var color = randomColors[0];
          if(userItem.size > 0){
            color = userItem.first().get("color");
          }
          else if(connections.size > 0){
            for(let i = 0; i <= randomColors.length; i++){
              connections.entrySeq().forEach(([key, value]) => {
                if(connections.getIn([action.socketId, "color"]) !== randomColors[i]){
                  color = randomColors[i];
                }
              })
            }
          }
        
          state = state.setIn(['connections', action.socketId, "color"], color);
        }
        
        state = state.setIn(['connections', action.socketId, "selectedItems"], action.selectedItems);
        state = state.setIn(['connections', action.socketId, "selectedScene"], 0);
        state = state.setIn(['connections', action.socketId, "projectUsr"], action.projectUsr);
        state = state.setIn(['connections', action.socketId, "userId"], action.userId);
        
        state = state.setIn(['connections', action.socketId, "projectUsrImg"], action.imageUrl);
      }

      return state;
    case "SOCKET_DISCONNECTED":
      state = state.set("connections", state.get("connections").delete(action.data));
     return state;
    break;

    case "OPEN_LIBRARY_SECTION_TOOGLE":
      state = state.set("openLibrarySection", action.data.status);
    return state;
    break;

    case "RESIZE_PROJECT":
      state = state.set("projectType", action.data.type);
    return state;
    
    case "SET_CURRENT_POSITION":
      state = state.set("currentPosition", action.data);
    return state;

    case 'FROM_OUTSIDE_UPLOAD':
      state = state.set('isUploadFromOutside', action.data);
    return state;

    case 'IS_UPLOAD_IN_PROCESS':
      state = state.set('isUploadInProcess', action.data);
      return state;

    case "NEW_SOCKET_CONNECTED":
    
      let connections = state.get("connections");
      if(!connections.has(action.data.socketId)){
        var userItem = connections.filter(function(obj, key){ return  obj.get("userId") === action.data.userId });
        var color = randomColors[0];
        if(userItem.size > 0){
          color = userItem.first().get("color");
        }
        else if(connections.size > 0){
          for(let i = 0; i <= randomColors.length; i++){
            connections.entrySeq().forEach(([key, value]) => {
              if(connections.getIn([action.data.socketId, "color"]) !== randomColors[i]){
                color = randomColors[i];
              }
            })
          }
        }
      
        state = state.setIn(['connections', action.data.socketId, "color"], color);
      }
      
      state = state.setIn(['connections', action.data.socketId, "selectedItems"], action.data.selectedItems.length > 0 ? action.data.selectedItems[0] : null);
      state = state.setIn(['connections', action.data.socketId, "selectedScene"], action.data.selectedScene);
      state = state.setIn(['connections', action.data.socketId, "projectUsr"], action.data.userName);
      state = state.setIn(['connections', action.data.socketId, "userId"], action.data.userId);
      
      state = state.setIn(['connections', action.data.socketId, "projectUsrImg"], action.data.imageUrl);
    return state;

    case 'SET_TEXT_FOCUS':
      state = state.update("isWorkspaceTextFocus", value => action.value);
      return state;

    

    case "UPDATE_RECENT_COLORS":
      state = state.set("recentColors", action.data.colors);  
    return state;



    case "MANAGE_TOAST":
      if(action.data.action === "add"){
        var toPush = {id : Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString()};
        toPush = Object.assign(toPush, action.data);
        state = state.set("toastNotifications", state.get("toastNotifications").push(fromJS(toPush)));
        
      }
      else if(action.data.action === "delete"){
        var allNotifications = state.get("toastNotifications");
        allNotifications = allNotifications.delete(allNotifications.findKey(x => x.get("id") === action.data.id));
        state = state.set("toastNotifications", allNotifications);
      }
      if(state.getIn(["loaders", "sharing"]) === true)
        state = state.setIn(["loaders", "sharing"], false);
      if(state.getIn(["loaders", "duplicate"]) === true)
        state = state.setIn(["loaders", "duplicate"], false);
    return state;

    case "SHARE_PROJECT":
      state = state.setIn(["loaders", "sharing"], true);
    return state;

    case "DUPLICATE_PROJECT":
      state = state.setIn(["loaders", "duplicate"], true);
    return state;

    case "UPDATE_USER_DETAILS":
      state = state.set("userDetails", state.get("userDetails").merge(fromJS(action.data)));
      if(action.data.anymsUser === false)
        state = state.set("isUserActive", 1);
    return state;

    case "UPDATE_FONTS" :
     
      if(!state.getIn(["loadedFonts", "scenes"]).has(action.data.selectedScene))
        state = state.setIn(["loadedFonts", "fonts"], action.data.fonts).setIn(["loadedFonts", "scenes"], state.getIn(["loadedFonts", "scenes"]).push(action.data.selectedScene));
      
    return state;

    case "FONT_LOADED" :
      
      let loadedIndex = state.getIn(["loadedFonts", "fonts"]).findKey(x => x.get("load") === action.data.load);
      if(loadedIndex !== undefined){
        state = state.setIn(["loadedFonts", "fonts", loadedIndex, "isLoaded"], true);
      
        state = state.setIn(["loadedFonts", "fontTracking", action.data.id], true);
        if(state.get('isfontLoadedTxtGrp'))
          state=state.set('isfontLoadedTxtGrp',false)
       

      }
    return state;

    case "FONT_ADDED" :
      state = state.updateIn(["loadedFonts", "fonts"], fonts => fonts.push(fromJS(action.data.font)));
    return state;

    case "MANAGE_SHARE" :
      let sharedIndex = state.get("sharedWith").findKey(x => x.get("email") === action.data.email);
      if(action.data.action === "delete"){
        if(sharedIndex !== undefined)
          state = state.set("sharedWith", state.get("sharedWith").delete(sharedIndex));
      }
      else if(action.data.action === "edit" || action.data.action === "view"){
        if(sharedIndex !== undefined)
          state = state.setIn(["sharedWith", sharedIndex, "edit"], action.data.action === "edit");
      }
      
    return state;

    case "CONFIRM_POPUP":
      
      state = state.set("confirmPopup", fromJS(action.data));
      if(action.data.isapplyEffecttoAllSlides===false){
        state=state.set("isapplyEffecttoAllSlides",fromJS(action.data.isapplyEffecttoAllSlides))
      }
     
    return state;




      case 'RESET_AUDIO_DATA':
          state = state.setIn(['ttsObj', 'isEdit'], false);
          state = state.setIn(['ttsObj', 'gender'], '');
          state = state.setIn(['ttsObj', 'lang'], '');
          state = state.setIn(['ttsObj', 'voice'], '');
          state = state.setIn(['ttsObj', 'data'], '');
          state = state.setIn(['ttsObj', 'isSpecific'], '');
          state = state.setIn(['ttsObj', 'audioData'], '');
          state = state.setIn(['ttsObj', 'audioId'], '');
      return state;

      case "UPLOAD_AGAIN":
        case "UPLOADED_FILE":
        if(action.data.anymsUser){
          state = state.set("anymsUploadStatus", "processing");
          state = state.set("isUploadFromOutside", true);
        }
      return state;
      
      case "UPLOAD_FAILED":
        if(state.get("anymsUploadStatus") === "processing"){
          state = state.set("anymsUploadStatus", "failed");
       
        }
      return state;
     
      case "UPDATE_BG":
        if(action.data.toUpdate.isBlob === false)
          state = state.set("anymsUploadStatus", "completed");
        if(action.data.toolCrop)
          state = state.setIn(["transformStatus", "transforming"], false);
      return state;
      case "ADD_HIGHLIGHTER":
          if(action.data.type === "upload_processing")
            state = state.set("highlightUpload", true);
      return state;

      case "UPDATE_SLIDE":
          if(action.data.subType === "BG_SETTINGS"){
            if(action.data.value.src === ""){
              if(state.getIn(["propertyWindow", "component"]) !== "")
              {
                state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
                state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
                state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
              }
            }
          }
      return state;

      case "UNDO_MOVE":
          state = state.set("undoResize", action.data.resizing);
      return state;
      case 'DRAGGED_FILE':
        state = state.set('draggedFile', action.data);
        return state;
      
      case "WRITE_TEXT":
     
        if(action.data.undo){
          state = state.setIn(["textStatus", "isFocused"], false);
        }
        if(action.data.isTyping === false){
          state = state.setIn(["textStatus", "currentText"], action.data.toUpdate.textData.htmlText).setIn(["textStatus", "currentWidth"], action.data.toUpdate.width).setIn(["textStatus", "currentHeight"], action.data.toUpdate.height).setIn(["textStatus", "currentX"], action.data.toUpdate.x).setIn(["textStatus", "currentY"], action.data.toUpdate.y);
        }
          
      return state;

      case "SET_TEXT_WIDTH":
     
        if(action.data.undo){
          state = state.setIn(["textStatus", "isFocused"], false);
        }
        if(action.data.isTyping === false){
          state = state.setIn(["textStatus", "currentText"], action.data.toUpdate.textData.htmlText).setIn(["textStatus", "currentWidth"], action.data.toUpdate.width).setIn(["textStatus", "currentHeight"], action.data.toUpdate.height).setIn(["textStatus", "currentX"], action.data.toUpdate.x).setIn(["textStatus", "currentY"], action.data.toUpdate.y);
        }
          
      return state;
      
      case "UPDATE_AUDIOS":
        case "UPDATE_AUDIOS_COMPLETE":
            state = state.set("selectedMedias", fromJS([]));
      return state;
   
      case "UPDATE_LOCALSTORE":
        state = state.merge(fromJS(action.data));
      case "UPDATE_SCENE":
        state = disableSelection(state);
        if(state.getIn(["propertyWindow", "component"]) !== "" && state.getIn(["propertyWindow", "component"]) !== "transition")
        {
          state = state.setIn(["propertyWindow", "component"], "").setIn(["propertyWindow", "isOpened"], false);
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], getPropertyWindowWidth(state.get('showSlidePanel'),state.getIn(["propertyWindow", "component"])));
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }
      return state;
      case "SET_SCENE":
        state = state.set("selectedScene", action.data.scene);
      return state;
      case "START_SCREENSHOT":
        state = state.setIn(["templateThumbnails", "status"], "started").setIn(["templateThumbnails", "totalScenes"], action.data.totalScenes).setIn(["templateThumbnails", "current"], 0).setIn(["templateThumbnails", "selectedScene"], state.get("selectedScene"));
      return state;
      case "UPDATE_THUMBNAILS":
        state = state.set("templateThumbnails", state.get("templateThumbnails").merge(action.data));
        if(action.data.status === "completed" || action.data.status === "failed"){
          state = state.set("selectedScene", state.getIn(["templateThumbnails", "selectedScene"]));
        }
      return state;
      case 'LIB_CURRENT_FOLDER':
        state = state.set('libCurrentFolder', action.data);
        return state;
        case "SET_FULSCREEN":
          state = state.setIn(['isFullScreen'], action.data.status);
          state = state.setIn(['zoomFactor'], action.data.zoomFactor);
          state = state.setIn(['prevZoomFactor'], action.data.prevZoomFactor);
          if(state.get("assetArray").length > 0)
            state = state.set("isWsTweenComplete", false)
          window.totalArr = state.get("assetArray")
        return state;

      case 'REMOVE_SCENE_POSITION':
        
        state = state.set('currentScene', null);
        state = state.set('currentSceneNumber', null);
        state = state.set('currentSceneStartTime', null);
        state = state.set('currentSceneDuration', null);
        
      return state;
     
      case 'SET_AUTO_PLAY':
        
      if(action.data !== undefined){
        state = state.set('autoPlay',action.data);
      }
      else{
      state = state.set('autoPlay',!state.get('autoPlay'));
      if(state.get('autoPlay')){
        state.get('t1').removePause().play();
      }
      else{
        state.get('t1').addPause(state.get('currentSceneStartTime')+state.get('currentSceneDuration'));
      }
      }
      return state;

      case 'SET_PREVIEW':
        state=state.set('isPreview',action.data);
      return state;
      
      case 'SET_WORKSPACE_STAGE':
        state = state.set('libSection',action.data);
        if(!action.data){
        state = state.setIn(["workspaceStage", "left", "menu"], 0);
        state = state.setIn(["workspaceStage", "left", "library"], 0);
        state = state.setIn(["workspaceStage", "left", "toggle"], 0);
        }
        else{
          state = state.setIn(["workspaceStage", "left", "menu"], 70);
          state = state.setIn(["workspaceStage", "left", "library"], 350);
          state = state.setIn(["workspaceStage", "left", "toggle"], 20);
        }
        if(!state.get('showSlidePanel') && state.getIn(['propertyWindow','component'])===""){
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], 0);
          if(state.get('isFit'))
         state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));

        }
        else if(state.get('showSlidePanel') || state.getIn(['propertyWindow','component'])!==""){
          state = state.setIn(["workspaceStage", "right", "maxPropertyWindow"], 300);
        if(state.get('isFit'))
          state = state.set("zoomFactor", getZoom(state.get("workspaceStage"), state.get("width"), state.get("height"), state.get("zoomFactor"), state.get("isFit")));
        }

      return state;

      
      case 'SET_ZOOM_FIT':
        state = state.set("isFit", action.data);
        return state

      case 'SET_APPLYEFFECT_SLIDES':
        state=state.set("isapplyEffecttoAllSlides",action.data);
        return state

      case "APPLY_ENTER_EFFECT_COMPLETE":
        if(action.currentSocketId === action.socketId && action.isUndo !== true){
          state = state.set("confirmPopup", fromJS({show : false}));
          if(action.effectData.isapplyToallSlides){
            state=state.set("isapplyEffecttoAllSlides",fromJS(action.effectData.isapplyToallSlides));
          }
        }
        if(action.isUndo === true && action.currentSocketId === action.socketId && Object.keys(action.sceneEffectData).length>1){
          state=state.set("isapplyEffecttoAllSlides",fromJS(!action.effectData.isapplyToallSlides));
        }

       return state;

       case "APPLY_ALL_TRANSITION":
        if(action.currentSocketId === action.socketId){
          state = state.set("confirmPopup", fromJS({show : false}));
        }

       return state;


       case 'SET_NEW_ACTION_COMPLETE':
          state = state.set('isNewAction',action.data)
        return state;

       case 'APP_CRASHED':
        state = state.set("hasAppCrashed", true);
        state = state.set("errorData", action.errorData);
        return state;
      case 'PROJECT_RESTORE':
        
        state = state.set('isProjectRestore',action.data.isRestore);
        state = state.set('versionId',action.data.versionId);
        return state;

        case 'LOAD_COMPLETE':
      
         state = state.set('loadComplete',action.loadComplete)
        return state;

        case 'BG_CATEGORY_LOAD':
          state = state.set('bgCategoryLoad',action.bgCategoryLoad)
          return state;

        case 'SET_PAYMENT_PAST_DUE':
          state = state.setIn(["userDetails","pastdue","status"],action.data.status);
          state = state.setIn(["userDetails","pastdue","message"],action.data.message);
        return state;

        case "INITIATE_MOVE":
          state = state.set("currentPosition", fromJS(action.data.currentPosition))
          return state;

        case "SET_IS_TEXTCLICKED":
          state = state.set("isTextClicked",action.data);
          return state;
        case "SET_ASSET_ARRAY":
          state = state.set("assetArray", action.data)
          return state;
    

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/localStore.js